import type { ButtonHTMLAttributes, ReactNode } from "react";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "primary" | "secondary" | "ghost";
  icon?: ReactNode;
  children: ReactNode;
};

const variants = {
  primary: "border-text/5 bg-text text-primary-contrast shadow-soft hover:bg-text/92",
  secondary: "border-border/70 bg-elevated text-text hover:bg-surface-warm",
  ghost: "border-transparent bg-transparent text-muted hover:bg-surface-soft hover:text-text"
};

export function Button({ variant = "primary", className = "", icon, children, ...props }: ButtonProps) {
  return (
    <button
      className={`inline-flex min-h-12 items-center justify-center gap-2 rounded-token border px-4 py-3 text-sm font-extrabold transition active:translate-y-px focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus/25 disabled:cursor-not-allowed disabled:opacity-60 ${variants[variant]} ${className}`}
      {...props}
    >
      {icon}
      {children}
    </button>
  );
}
